import { createAction, props } from '@ngrx/store';
import { TimesheetTypes } from './timesheet.type';
import {
  ClockInModel,
  ClockOutModel,
  IFileModel,
  TimesheetLogsModel,
} from './timesheet.model';
import { MoodEnum } from 'app/utils/enums/timesheet.enum';

export const clockIn = createAction(
  TimesheetTypes.POST_CLOCK_IN,
  (payload: ClockInModel) => ({
    payload,
  })
);
export const clockInSuccess = createAction(
  TimesheetTypes.POST_CLOCK_IN_SUCCESS,
  (payload: any) => ({
    payload,
  })
);
export const clockInCancel = createAction(TimesheetTypes.POST_CLOCK_IN_CANCEL);

export const clockOut = createAction(
  TimesheetTypes.POST_CLOCK_OUT,
  (payload: ClockOutModel) => ({
    payload,
  })
);
export const clockOutSuccess = createAction(
  TimesheetTypes.POST_CLOCK_OUT_SUCCESS,
  (payload: any) => ({
    payload,
  })
);
export const clockOutCancel = createAction(
  TimesheetTypes.POST_CLOCK_OUT_CANCEL
);

export const getTimesheetLogs = createAction(TimesheetTypes.GET_TIMESHEET_LOGS);
export const getTimesheetLogsSuccess = createAction(
  TimesheetTypes.GET_TIMESHEET_LOGS_SUCCESS,
  (payload: Array<TimesheetLogsModel>) => ({
    payload,
  })
);
export const getTimesheetLogsCancel = createAction(
  TimesheetTypes.GET_TIMESHEET_LOGS_CANCEL
);

export const fileUploadAction = createAction(
  TimesheetTypes.File_Upload,
  (payload: FormData) => ({
    payload,
  })
);

export const cancelFileUploadAction = createAction(
  TimesheetTypes.Cancel_File_Upload
);

export const fileUploadSuccessAction = createAction(
  TimesheetTypes.File_Upload_Success,
  (payload: IFileModel) => ({ payload })
);

export const fileUploadFailedAction = createAction(
  TimesheetTypes.File_Upload_Failed,
  (payload: any) => ({
    payload,
  })
);
